export default __webpack_public_path__ + "static/hiit_it_interval_timer_iphone-reset@2x-8c211c4b9d2cacfdea2518eab89c0527.webp";